<template>
  <div
    class="relative h-9 overflow-visible"
    style="contain: layout"
  >
    <!-- div to cover entry of text input component from right of
    screen -->
    <div
      class="absolute inset-y-0 right-0 z-20 w-11 bg-background"
    >
    </div>
    <div
      class="pointer-events-auto absolute inset-y-0 right-2 z-20 flex w-9 items-center justify-center rounded-r-md bg-background text-background-fg"
      :class="{
        'border-y border-r border-background-opaque':
          isInputVisible,
      }"
    >
      <IconX
        v-if="modelValue"
        @click="handleClearInput"
        @mousedown.prevent
      />
      <IconSearch
        v-else
        @click="activateInput"
        @mousedown="handleSearchIconMouseDown"
      />
    </div>
    <Transition
      enter-active-class="transform transition-all duration-300 ease-out"
      enter-from-class="opacity-0 translate-x-full"
      enter-to-class="opacity-100 translate-x-0"
      leave-active-class="transform transition-all duration-200 ease-in"
      leave-from-class="opacity-100 translate-x-0"
      leave-to-class="opacity-0 translate-x-full"
    >
      <!-- -left-7 is to acheive a border of size 2 on the left (matching right-2 above). Home icon is w-5 with ml-4, so total width of 9. -->
      <!-- right-11 is to align with edge of icon div above with w-9 and right-2 -->
      <div
        v-if="isInputVisible"
        class="absolute -left-7 right-11"
      >
        <BaseTextInput
          ref="inputRef"
          :model-value="modelValue"
          placeholder="search"
          class="rounded-r-none border-none bg-background-opaque pl-4 text-left focus:border-transparent focus:outline-none focus:ring-0"
          @update:model-value="handleInnerInputUpdate"
          @blur="handleBlur"
        />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string
}>()

const isInputVisible = ref(false)
const inputRef = useTemplateRef("inputRef")

const emit = defineEmits<{
  (eventName: "update:modelValue", value: string): void
}>()

const handleInnerInputUpdate = (value: string) => {
  emit("update:modelValue", value)
}

const handleClearInput = () => {
  emit("update:modelValue", "")
}

const isClosingViaSearchIcon = ref(false)

const handleSearchIconMouseDown = () => {
  // Set flag when empty input blurred via search icon click
  if (isInputVisible.value && !props.modelValue) {
    isClosingViaSearchIcon.value = true
  }
}

const activateInput = async () => {
  if (isInputVisible.value) return
  isInputVisible.value = true
  await nextTick() // Wait for the input to be mounted before focusing
  inputRef.value?.$el?.focus()
}

const handleBlur = () => {
  // Hide input when blurred and empty, but not if search icon was clicked
  if (!props.modelValue && !isClosingViaSearchIcon.value) {
    isInputVisible.value = false
  } else {
    inputRef.value?.$el?.focus()
    isClosingViaSearchIcon.value = false
  }
}
</script>
